import { render, staticRenderFns } from "./designBro.vue?vue&type=template&id=d854306e&scoped=true"
import script from "./designBro.vue?vue&type=script&lang=js"
export * from "./designBro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d854306e",
  null
  
)

export default component.exports